import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterNumberSearchValueObject} from './FilterNumberSearchValueObject.js'
import {FilterStringSearchValueObject} from './FilterStringSearchValueObject.js'
export class FilterLocationSearchValueObject extends ValueObject {
  #location

  constructor({location}) {
    super()
    this.#location = location
  }

  static create({location}) {
    return new FilterLocationSearchValueObject({
      location: {
        lat: FilterNumberSearchValueObject.create(location.lat),
        long: FilterNumberSearchValueObject.create(location.long),
        radio: FilterNumberSearchValueObject.create(location.radio),
        text: FilterStringSearchValueObject.create(location.text),
        provinceId: FilterNumberSearchValueObject.create(location.provinceId)
      }
    })
  }

  static createWithDefaultValue({config, location}) {
    const {DEFAULT_LOCATION_SEARCH} = config.get('searchFilters')

    return new FilterLocationSearchValueObject({
      location: {
        lat: FilterNumberSearchValueObject.create({
          number: location?.latitude ?? location?.lat ?? DEFAULT_LOCATION_SEARCH.lat
        }),
        long: FilterNumberSearchValueObject.create({
          number: location?.longitude ?? location?.long ?? DEFAULT_LOCATION_SEARCH.long
        }),
        radio: FilterNumberSearchValueObject.create({
          number: location?.distance ?? location?.radio ?? DEFAULT_LOCATION_SEARCH.radio
        }),
        text: FilterStringSearchValueObject.create({
          string: location?.text ?? DEFAULT_LOCATION_SEARCH.text
        }),
        provinceId: FilterNumberSearchValueObject.create({
          number: location?.provinceId ?? DEFAULT_LOCATION_SEARCH.provinceId
        })
      }
    })
  }

  static createQueryParams({config, location}) {
    const {DEFAULT_LOCATION_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterLocationSearchValueObject({
      location: {
        lat: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.LOCATION].lat,
          value: location?.lat ?? DEFAULT_LOCATION_SEARCH.lat
        }),
        long: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.LOCATION].long,
          value: location?.long ?? DEFAULT_LOCATION_SEARCH.long
        }),
        radio: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.LOCATION].radio,
          value: location?.radio ?? DEFAULT_LOCATION_SEARCH.radio
        }),
        text: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.LOCATION].text,
          value: location?.text ?? DEFAULT_LOCATION_SEARCH.text
        }),
        provinceId: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.LOCATION].provinceId,
          value: location?.provinceId ?? DEFAULT_LOCATION_SEARCH.provinceId
        })
      }
    })
  }

  get isEmpty() {
    return (
      this.#location.lat.isEmpty &&
      this.#location.long.isEmpty &&
      this.#location.radio.isEmpty &&
      this.#location.text.isEmpty &&
      this.#location.provinceId.isEmpty
    )
  }

  get queryParams() {
    return {
      ...(!this.#location.lat.isEmpty && {...this.#location.lat.queryParam}),
      ...(!this.#location.long.isEmpty && {...this.#location.long.queryParam}),
      ...(!this.#location.radio.isEmpty && {...this.#location.radio.queryParam}),
      ...(!this.#location.text.isEmpty && {...this.#location.text.queryParam}),
      ...(!this.#location.provinceId.isEmpty && {...this.#location.provinceId.queryParam})
    }
  }

  get lat() {
    return this.#location.lat.value
  }

  get long() {
    return this.#location.long.value
  }

  get radio() {
    return this.#location.radio.value
  }

  get text() {
    return this.#location.text.value
  }

  get provinceId() {
    return this.#location.provinceId.value
  }

  get value() {
    return {
      lat: this.#location.lat.value,
      long: this.#location.long.value,
      radio: this.#location.radio.value,
      text: this.#location.text.value,
      provinceId: this.#location.provinceId.value
    }
  }

  toApi() {
    if (this.isEmpty) return undefined

    const apiData = {
      latitude: this.lat,
      longitude: this.long,
      distance: this.radio,
      text: this.text
    }

    if (this.provinceId !== null && this.provinceId !== undefined) {
      apiData.provinceId = this.provinceId
    }

    return apiData
  }

  toJSON() {
    return {
      location: {
        lat: this.#location.lat.toJSON(),
        long: this.#location.long.toJSON(),
        radio: this.#location.radio.toJSON(),
        text: this.#location.text.toJSON(),
        provinceId: this.#location.provinceId.toJSON()
      }
    }
  }
}
